// extracted by mini-css-extract-plugin
module.exports = {"Page":"RoomsOfPlace_Page__hBR6K"};